<template>
  <login-signup-tabs :starting-tab="1" :line="line">
    <p class="title has-text-centered">New to tinythoughts? Sign up!</p>
  </login-signup-tabs>
</template>

<script>
import LoginSignupTabs from '@/components/Login/LoginSignupTabs.vue'

export default {
  name: 'WelcomeModal',
  props: ['line'],
  components: {
    LoginSignupTabs,
  }
};
</script>

<style scoped lang="scss">

</style>
